import { ContactDetails } from '../../../../../api/models';
import {
  isEmailValid,
  isPhoneValid,
  isZipCodeValid,
} from '../../../../../core';

export const IsContactInformationValid = (
  contactDetails: ContactDetails
): boolean => {
  return (
    contactDetails.mailingAddress !== '' &&
    contactDetails.city !== '' &&
    contactDetails.state !== '' &&
    isZipCodeValid(contactDetails.zip, true) &&
    isPhoneValid(contactDetails.phoneNumber, true) &&
    isPhoneValid(contactDetails.mobileNumber, false) &&
    isEmailValid(contactDetails.emailAddress, true) &&
    true
  );
};
